import { render, staticRenderFns } from "./route-info-v2-city-table-header.vue?vue&type=template&id=58d6655b&scoped=true&"
import script from "./route-info-v2-city-table-header.vue?vue&type=script&lang=ts&"
export * from "./route-info-v2-city-table-header.vue?vue&type=script&lang=ts&"
import style0 from "./route-info-v2-city-table-header.vue?vue&type=style&index=0&id=58d6655b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6655b",
  null
  
)

export default component.exports